import { useReactToPrint } from "react-to-print";
import { useRef } from "react";

/**
 * Hook providing print functionality for reports with custom page styling
 * 
 * @param documentTitle - Title for the printed document
 * @returns Object with handlePrint function and contentRef for the element to print
 */
export const usePrintHandler = (documentTitle: string) => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle,
    pageStyle: `
      @page { 
        size: letter portrait;
        margin: 8mm;
      }
      @media print {
        body { 
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }
      }
    `,
  });

  return { handlePrint, contentRef };
};
